module.exports = __webpack_public_path__ + "img/QuilityLogoSymbolGreenRGB.020ffbd0.svg";